import React from 'react';
import { Container, Mask } from './SettingsContainer.styles';

var SettingsContainer = function SettingsContainer(_ref) {
  var children = _ref.children,
      isDisabled = _ref.isDisabled;
  return React.createElement(Container, {
    "data-testid": "settings-container"
  }, children, isDisabled && React.createElement(Mask, null));
};

export default SettingsContainer;